import React from 'react';
import PropTypes from 'prop-types';
import {Screen} from '../Screen';
import {Input} from './Input';
import {Seperation} from './Seperation';
import {Text} from './Text';
import ScreenImage from '@learningblocks/exp-constants/lib/Images/ps_timer_screen.svg';
import {useTranslation} from 'react-i18next';

import './style.scss';

const TRANSLATION_KEY = {
  HH: 'HH.string',
  MM: 'MM.string',
  SS: 'SS.string',
};

export function TimerDisplay(props) {
  const [hours, setHours] = React.useState();
  const [minutes, setMinutes] = React.useState();
  const [seconds, setSeconds] = React.useState();

  const {t} = useTranslation();

  React.useEffect(() => {
    setHours(props.timeData.getHours());
    setMinutes(props.timeData.getMinutes());
    setSeconds(props.timeData.getSeconds());
  }, [props.timeData]);

  const setTimerSeconds = (seconds) => {
    let time = new Date(props.timeData.getTime());
    time.setSeconds(seconds);
    props.setTimer(time);
  };
  const setTimerMinutes = (minutes) => {
    let time = new Date(props.timeData.getTime());
    time.setMinutes(minutes);
    props.setTimer(time);
  };
  const setTimerHours = (hours) => {
    let time = new Date(props.timeData.getTime());
    time.setHours(hours);
    props.setTimer(time);
  };

  return (
    <Screen className='ps_settings_timerDisplay' imageSrc={ScreenImage} ariaLabel={`Current time is to ${hours} hours,  ${minutes} minutes and ${seconds} seconds.`}>
      <div className='ps_settings_timerDisplay_inputBlock'>
        <Text className='hhText'> {t(TRANSLATION_KEY.HH)} </Text>
        <Input
          className='ps_settings_timerDisplay_inputBlock_input  hh_input'
          value={hours}
          setValue={setTimerHours}
          ariaLabel={`hours input. Current hour set at ${hours} hours.`}
        />
        <Seperation className='hh_mm_seperator' />
        <Text className='mmText'> {t(TRANSLATION_KEY.MM)}</Text>
        <Input
          className='ps_settings_timerDisplay_inputBlock_input  mm_input'
          value={minutes}
          setValue={setTimerMinutes}
          ariaLabel={`minutes input. Current minutes set at ${minutes} minutes.`}
        />
        <Seperation className='mm_ss_seperator' />
        <Text className='ssText'> {t(TRANSLATION_KEY.SS)}</Text>
        <Input
          className='ps_settings_timerDisplay_inputBlock_input  ss_input'
          value={seconds}
          setValue={setTimerSeconds}
          ariaLabel={`seconds input. Current seconds set at ${seconds} seconds.`}
        />
      </div>
    </Screen>
  );
}

Screen.propTypes = {
  /**
   * date time data for timer
   */
  timeData: PropTypes.instanceOf(Date),
  /**
   * callback function to set time value
   */
  setTimer: PropTypes.func,
};

Screen.defaultProps = {
  className: '',
};
